/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

export default class AccessTokenModel {
  /**
   * Creates an instance of AccessTokenModel.
   * @param {Object} token - Access token object from API
   * @class AccessTokenModel
   * @property {string} id - Access token id
   * @property {string} tokenName - Access token display name
   * @property {Array<string>} permissions - List of permissions assigned to token
   * @property {number} permissionsCount - Number of permissions assigned to token
   * @property {string} createdAt - Creation timestamp
   * @property {string|null} lastUsed - Last usage timestamp
   * @property {string} expiryDate - Expiration timestamp
   * @property {string} status - Token status (active/revoked/expired)
   * @property {string|null} revocationInfo - Additional information about token revocation
   */
  constructor(token = {}, neverUsedText = '') {
    this.id = token._id;
    this.tokenName = token.name;
    this.permissions = token.permissions;
    this.permissionsCount = (token.permissions && token.permissions.length) || 0;
    this.created = AccessTokenModel.formatDate(token.createdAt);
    this.lastUsed = AccessTokenModel.formatDate(token.lastUsedAt, neverUsedText);
    this.expiryDate = AccessTokenModel.formatDate(token.expiresAt);
    this.status = token.status;
    this.revocationInfo = token.revocationInfo || null;
  }

  static formatDate(value, fallback = '') {
    return value ? new Date(value).toLocaleString('en-GB') : fallback;
  }
}
